const HEADING_TASK_NAME = 'Sign Disclosures';
const HEADING_TASK_DESCRIPTION = 'Documents that provide information to borrowers about the terms and conditions of their mortgage loan, including interest rates, fees, and other costs associated with the loan.';
const ESignConstants = {
  HEADING_TASK_NAME,
  HEADING_TASK_DESCRIPTION
};
export default ESignConstants;
//# sourceMappingURL=index.js.map